<template>
  <div class="m-3" style="height: 90vh">
    <div class="grid grid-cols-12 items-center content-center gap-2">
      <el-select
          class="input-label col-span-12 md:col-span-2"
          v-model="selectedValue"
          @change="applyToSelected"
      >
        <el-option
            key="export"
            :label="$t('views.common.listView.selectedRows.export')"
            value="export"
        >
        </el-option>
      </el-select>

      <el-input
          :placeholder="$t('views.common.listView.searchRows')"
          class="w-full col-span-12 md:col-span-10"
          :prefix-icon="Search"
          v-model="searchTerm"
      />


    </div>

    <ag-grid-vue
        class="ag-theme-alpine mt-4 md:mt-0"
        :columnDefs="columnDefs"
        :rowData="rowData"
        rowSelection="multiple"
        :enable-rtl="$ctx.getDir() === 'rtl'"
        style="height: 85vh"
        :pagination="true"
        :paginationAutoPageSize="true"
        :defaultColDef="defaultColDef"
        :onGridReady="onGridReady"
    >
    </ag-grid-vue>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

// components
import {AgGridVue} from 'ag-grid-vue3'
import {ColDef, GridApi, GridOptions} from 'ag-grid-community'

import {useI18n} from 'vue-i18n'
import {Search} from '@element-plus/icons-vue'
import AddMissingSerialsAction from "@/views/inventory/missingSerials/AddMissingSerialsAction.vue";
import {ItemMissingSerials} from "@/models/inventory/ItemMissingSerials";

export default defineComponent({
  name: 'missing-serials',

  setup() {
    const {t} = useI18n({
      messages: {
        en: {
          name: 'Item Name',
          quantity: 'Quantity',
          totalMissing: 'Total Missing',
          totalSerials: 'Total Serials',
          location: 'Store Name',
          action: 'Action',
        },
        ar: {
          name: 'اسم المادة',
          quantity: 'الكمية',
          totalMissing: 'المفقودة',
          totalSerials: 'الارقام التسلسلية',
          location: 'اسم المتجر',
          action: 'العمليات',
        }
      }
    })

    return {
      t,
      Search
    }
  },

  data() {
    const columnDefs: ColDef[] = []
    const rowData: any[] = []
    const gridOptions: GridOptions = {}
    const defaultColDef: ColDef = {}

    return {
      columnDefs,
      rowData,
      gridOptions,
      defaultColDef,

      searchTerm: '',
      selectedValue: '',
      gridApi: undefined as GridApi | undefined
    }
  },

  components: {
    AgGridVue,
  },

  beforeMount() {
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 150
    }

    this.columnDefs = [
      {
        headerName: this.t('name'),
        field: 'name',
        checkboxSelection: true,
        headerCheckboxSelection: true
      },
      {
        headerName: this.t('totalSerials'),
        field: 'total_serials',
      },
      {
        headerName: this.t('totalMissing'),
        field: 'quantity',
        valueFormatter: ({data}) => {
          if (!data) return '';
          return data.quantity - data.total_serials
        }
      },
      {
        headerName: this.t('location'),
        valueFormatter: ({data}) => {
          if (!data) return '';
          if (this.$ctx.locale == 'ar') {
            return data.location_ar_name
          }
          return data.location_en_name
        }
      },
      {
        headerName: this.t('action'),
        field: 'id',
        cellRenderer: AddMissingSerialsAction
      }
    ]
  },

  mounted() {
  },

  watch: {
    searchTerm() {
      this.filterItems()
    }
  },

  methods: {
    async updateRowData() {
      this.gridApi?.showLoadingOverlay()

      try {
        const data = await this.$http.get<ItemMissingSerials[]>(ItemMissingSerials.ENDPOINT)
        this.rowData = data;
      } catch (error) {
        this.$alertModal.showDanger({
          title: error.title,
          body: error.body
        })
      }

      this.gridApi?.hideOverlay()
    },

    async onGridReady(params: any) {
      this.gridApi = params.api
      await this.updateRowData()
    },

    async applyToSelected() {
      if (this.selectedValue === 'export') {
        const selected = this.gridApi?.getSelectedRows()

        if (selected?.length) {

          this.gridApi?.exportDataAsCsv({onlySelected: true})
          this.$alertModal.showSuccess({
            title: this.$t('views.common.listView.selectedRows.exportSuccess')
          })

          // deselect
          selected.length = 0
        }
      }

      this.selectedValue = ''
    },

    filterItems() {
      this.gridApi?.setQuickFilter(this.searchTerm)
    },
  }
})
</script>

<style></style>
